export default "__VITE_ASSET__DG1_v5dY__"